module.exports = __webpack_public_path__ + "static/img/4777_phase_function_Paper_PointsHejduk_Prediction.276a44f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4777_phase_function_Paper_PointsHejduk_Prediction.png
// module id = os8f
// module chunks = 0